module.exports = __webpack_public_path__ + "img/weixin.e8bbd784.jpg";